'use strict';

document.addEventListener('DOMContentLoaded', () => {
  const popupError = document.querySelector('.popup-error');
  const popupDemo = document.querySelector('.popup-demo');
  const popupDemoInner = document.querySelector('.popup-demo__inner');
  const noDemo = document.querySelectorAll('.js-no-demo');
  const demoButtons = document.querySelectorAll('[data-demo]');

  if(noDemo) {
    noDemo.forEach((button) => {
      button.addEventListener('click', () => {
        popupError.classList.add('popup--active');
      })
    });
  }

  if(demoButtons) {
    demoButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const demo = e.target.getAttribute('data-demo');
        let iframe = document.createElement('iframe');
        iframe.setAttribute('src', demo);
        popupDemoInner.append(iframe);
        popupDemo.classList.add('popup--active');
      })
    });
  }

});